export enum TAG {
    BETA = "beta",
    NEW = "new",
}
